import {firstValueFrom, Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {catchError, map} from "rxjs/operators";

import {ClienteDTO, IPaginadoDTO, IPanelDTO, PaginadoDTO, PanelDTO} from "@DTOS";
import { Constants } from "@constants";
import { of } from "rxjs";
import {DatosModalPanel} from "../layout/saas/crear-desde-archivo-modal/DatosModalPanel";

@Injectable({
    providedIn: "root"
})
export class PanelsServiceBackend {
    constructor(protected httpClient: HttpClient) {}



    public getPanels(cantidad = 10, pagina = 1): Observable<PaginadoDTO<PanelDTO>> {
        return this.httpClient.get<IPaginadoDTO<IPanelDTO>>(
            `${Constants.apiURL}/panels?size=${cantidad}&page=${pagina}`
        ).pipe(
            map(response => new PaginadoDTO<PanelDTO>({
                ...response,
                results: response.results.map(panel => new PanelDTO(panel))
            }))
        );
    }
    public async getPanel(id: number): Promise<PanelDTO> {
        return await firstValueFrom(
            this.httpClient.get<IPanelDTO>(`${Constants.apiURL}/panels/${id}`).pipe(
                map(panel => new PanelDTO(panel))
            )
        );
    }

    public async postPanels(panel: PanelDTO): Promise<PanelDTO> {
        return await firstValueFrom(
            this.httpClient.post<IPanelDTO>(`${Constants.apiURL}/panels`, panel.obtenerJSON()).pipe(
                map(panelDTO => new PanelDTO(panelDTO))
            )
        );
    }

    public async putPanel(panel: PanelDTO): Promise<PanelDTO> {
        return await firstValueFrom(
            this.httpClient.put<IPanelDTO>(
                `${Constants.apiURL}/panels/${panel.id}`, panel.obtenerJSON()
            ).pipe(
                map(panelDTO => new PanelDTO(panelDTO))
            )
        );
    }

    public async deletePanel(panel: PanelDTO): Promise<boolean> {
        return await firstValueFrom(
            this.httpClient.delete(`${Constants.apiURL}/panels/${panel.id}`).pipe(
                map(() => true),
                catchError(() => of(false))
            )
        );
    }

    public async postSubirArchivo(id: number, archivo: Blob, dashboard: boolean): Promise<void> {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("isDashboard", dashboard.toString());
        await firstValueFrom(this.httpClient.post(`${Constants.apiURL}/panels/${id}/upload`, formData));
    }

    public async postCrearDesdeArchivo(datos: DatosModalPanel, clientes: ClienteDTO[], archivo: Blob): Promise<void> {
        for (const cliente of clientes) {
            const formData = new FormData();
            const jsonData = JSON.stringify({
                brand: datos.marca,
                type: datos.tipo,
                customer: cliente.id,
                sample_size: datos.numCasos,
                payload: {
                    paises: datos.paises.map(pais => pais.codigo),
                    periodo: datos.periodo
                }
            });

            formData.append("file", archivo);
            formData.append("data", jsonData);

            await firstValueFrom(this.httpClient.post(`${Constants.apiURL}/panels/create_from_file`, formData));
        }
    }

}
